/* This example requires Tailwind CSS v2.0+ */
import * as React from "react";
import S from "./Offices.styled";
import { Link } from "gatsby";
import { IWPLink } from "@/src/types";
import Map, { FullscreenControl, Marker } from "react-map-gl/mapbox";

export interface Props {
  preTitle: string;
  title: string;
  text: string;
  offices: {
    title: string;
    text: string;
    longitude: number;
    latitude: number;
    zoom: number;
    googleMapsLink: IWPLink;
    ctaLink: IWPLink;
  }[];
}

const Cta: React.FC<Props> = ({ preTitle, title, text, offices }) => {
  console.log("offices", offices);

  return (
    <section id="kontor" className="relative w-full p-12 bg-mGray-100">
      <S.OfficeGrid
        className={
          "md:mx-auto md:max-w-7xl relative block lg:grid flex flex-col gap-12 grid-cols-2 grid-flow-col justify-between"
        }
      >
        <div className={"flex-1"}>
          <h4 className="text-mGray-500 mb-0">{preTitle && preTitle}</h4>
          <h2 className="mt-0">{title && title}</h2>
          <div className="lg:h-64 h-auto">
            <p
              className="mb-4"
              dangerouslySetInnerHTML={{ __html: text && "" }}
            ></p>
          </div>
        </div>
        <div
          className={
            "flex-1 relative block md:grid grid-cols-3 grid-flow-col gap-4 items-stretch"
          }
        >
          {offices.map((office, idx) => (
            <S.Office key={idx}>
              <S.OfficeInfo
                className={
                  "relative my-4 bg-white rounded-md overflow-hidden shadow-lg flex flex-col items-stretch"
                }
              >
                <div className="relative" style={{ height: "250px" }}>
                  <Map
                    initialViewState={{
                      longitude: office.longitude && office.longitude,
                      latitude: office.latitude && office.latitude,
                      zoom: office.zoom && office.zoom,
                    }}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    mapboxAccessToken={process.env.GATSBY_MAPBOX_TOKEN}
                    style={{ width: "338px", height: "100%" }}
                  >
                    <Marker
                      longitude={office.longitude}
                      latitude={office.latitude}
                      anchor="bottom"
                    >
                      <img src="/marker.png" style={{ height: "40px" }} />
                    </Marker>
                    <FullscreenControl />
                  </Map>
                </div>
                <div className={"px-6 py-6"}>
                  <h3 className="line-clamp-2 text-2xl m-0">
                    {office?.title && office.title}
                  </h3>
                  <a
                    href={office.googleMapsLink.url}
                    target="_blank"
                    className="font-bold text-right text-metlab-500 uppercase text-sm"
                  >
                    {office.googleMapsLink.title}
                  </a>

                  <p
                    className="mt-3 mb-8"
                    dangerouslySetInnerHTML={{ __html: office.text }}
                  ></p>

                  {office?.ctaLink &&
                    office?.ctaLink.url &&
                    office.ctaLink.title && (
                      <Link to={office.ctaLink.url}>
                        <S.Associates
                          className={
                            "absolute bottom-5 uppercase text-metlab-500 font-bold flex items-center"
                          }
                        >
                          {office.ctaLink.title}{" "}
                          <i className="bx bxs-right-arrow-alt text-metlab-500 ml-2"></i>
                        </S.Associates>
                      </Link>
                    )}
                </div>
              </S.OfficeInfo>
            </S.Office>
          ))}
        </div>
      </S.OfficeGrid>
    </section>
  );
};

export default Cta;
